import utcToLocal from '../../Src/Utils/UtcToLocal';

export default {
    methods: {
        utcToLocal,
    }
}